import { Wrench, MapPin, Phone, Mail } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../mock";

export const Footer = () => (
  <footer data-testid="footer-section">
    <div className="bg-[#c8102e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center w-11 h-11 rounded-full bg-[#191512]">
              <Wrench className="w-5 h-5 text-white" strokeWidth={2.5} />
            </span>
            <span className="leading-tight">
              <span className="block font-condensed font-black uppercase text-white text-2xl tracking-wide">
                Napolano Impianti
              </span>
              <span className="block font-condensed font-bold uppercase text-[#191512] text-xs tracking-widest">
                {COMPANY.tagline}
              </span>
            </span>
          </div>
          <p className="mt-5 text-white/90 text-sm leading-relaxed max-w-xs">
            {COMPANY.name}: la {COMPANY.productName} per casa e ufficio.
            Impianti elettrici, idraulici e manutenzioni in generale a {COMPANY.area}.
          </p>
        </div>
        <div>
          <h3 className="font-condensed font-bold uppercase tracking-wide text-white text-xl">Link rapidi</h3>
          <ul className="mt-5 space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.testid.replace("nav-link-", "")}`}
                  className="text-white/90 hover:text-[#191512] text-sm font-medium transition-colors duration-200"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a href="#servizi" data-testid="footer-link-servizi" className="text-white/90 hover:text-[#191512] text-sm font-medium transition-colors duration-200">
                Tutti i servizi
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="font-condensed font-bold uppercase tracking-wide text-white text-xl">Contatti</h3>
          <ul className="mt-5 space-y-3 text-sm text-white/90">
            <li className="flex items-start gap-2.5">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
              <span data-testid="footer-address">{COMPANY.address}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone className="w-4 h-4 shrink-0" />
              <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="hover:text-[#191512] transition-colors duration-200">
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail className="w-4 h-4 shrink-0" />
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="hover:text-[#191512] transition-colors duration-200 break-all">
                {COMPANY.email}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="bg-[#191512]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p data-testid="footer-copyright" className="text-white/70 text-xs text-center">
          © 2026 {COMPANY.name} — P.IVA {COMPANY.piva} — {COMPANY.rea}. Tutti i diritti riservati.
        </p>
        <div className="flex gap-5 text-xs text-white/60">
          <a href="#home" data-testid="footer-privacy-link" className="hover:text-[#4caf7d] transition-colors duration-200">Privacy Policy</a>
          <a href="#home" data-testid="footer-terms-link" className="hover:text-[#4caf7d] transition-colors duration-200">Termini e Condizioni</a>
        </div>
      </div>
    </div>
  </footer>
);
